<div
  class="flex h-[100dvh] overflow-hidden"
  [ngClass]="behaviourStates.sidebarOpen ? 'sidebar-expanded' : ''"
>
  <div>
    <div
      class="fixed inset-0 bg-slate-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200"
      [ngClass]="
        behaviourStates.sidebarOpen
          ? 'opacity-100'
          : 'opacity-0 pointer-events-none'
      "
      (click)="toggleSidebar()"
      data-testid="app-layout-sidebar-backdrop"
      data-test-desc="Fondo oscuro para cerrar el sidebar al hacer clic"
    ></div>
    <div
      class="flex flex-col absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 h-[100dvh] overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 lg:w-20 lg:sidebar-expanded:!w-64 shrink-0 bg-slate-800 p-4 transition-all duration-200 ease-in-out"
      data-testid="app-layout-sidebar-panel"
      [ngClass]="
        behaviourStates.sidebarOpen ? 'translate-x-0' : '-translate-x-64'
      "
    >
      <div class="flex justify-between mb-10 pr-3 sm:px-2">
        <button
          class="lg:hidden text-slate-500 hover:text-slate-400"
          (click)="toggleSidebar()"
          data-testid="app-layout-close-sidebar-btn"
          data-test-desc="Botón para cerrar el sidebar en móvil"
        >
          <span class="sr-only">Close sidebar</span>
          <svg
            class="w-6 h-6 fill-current"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z"
            />
          </svg>
        </button>
        <!-- El logo lleva a «Mi perfil»: el dashboard está desmontado (ver app.routes.ts). -->
        <a
          class="block"
          [routerLink]="['./account']"
          data-testid="app-layout-logo-link"
          data-test-desc="Enlace del logo para ir a Mi perfil"
        >
          <img
            class="object-contain object-center h-12 sidebar-expanded:hidden"
            [src]="logoIso$ | async"
            alt="App Logo"
          />
          <img
            class="object-contain object-center h-12 hidden sidebar-expanded:block"
            [src]="logoMain$ | async"
            alt="App Logo"
          />

        </a>
      </div>
      <div class="space-y-8">
        <div>
          <h3 class="text-xs uppercase text-slate-500 font-semibold pl-3">
            <span
              class="hidden lg:block lg:sidebar-expanded:hidden text-center w-6"
              >•••</span
            >
            <span class="lg:hidden lg:sidebar-expanded:block"
              >Administración</span
            >
          </h3>
          <ul class="mt-3 select-none">
            <!-- Caja: solo con caja abierta. La apertura sigue en la taquilla de cada experiencia. -->
            <li
              *ngIf="cashierSessionOpen"
              class="px-3 py-2 rounded-sm mb-0.5 last:mb-0"
            >
              <a
                class="block text-slate-200 truncate transition duration-150 cursor-pointer"
                (click)="openCashierCloseModal()"
              >
                <div class="flex items-center">
                  <svg
                    class="shrink-0 h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path class="fill-current text-slate-600" d="M2 6h20v12H2V6zm2 2v8h16V8H4z" />
                    <path class="fill-current text-slate-400" d="M12 9a3 3 0 110 6 3 3 0 010-6z" />
                  </svg>
                  <span
                    class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                    >Cerrar caja</span
                  >
                </div>
              </a>
            </li>

            <!-- Productor -->
            <li
              *appValidateAccess="'CREAR_INFORMACION_EXP'"
              class="px-3 py-2 rounded-sm mb-0.5 last:mb-0"
              routerLinkActive="sidebar-element-expanded bg-slate-900"
              cdkAccordion
            >
              <a
                class="block text-slate-200 truncate transition duration-150 cursor-pointer"
                [routerLink]="['./producer']"
                data-testid="app-layout-producer-link"
                data-test-desc="Enlace para ir a crear experiencia (productor)"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center">
                    <svg
                      class="shrink-0 h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        class="fill-current text-slate-400"
                        routerLinkActive="!text-gl-blue"
                        d="M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c0 0 0 0 .1 0l5.5 0 112 0 5.5 0c0 0 0 0 .1 0l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2z"
                      />
                    </svg>
                    <span
                      class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                      [routerLink]="['./producer']"
                      routerLinkActive="!text-gl-blue"
                      data-testid="app-layout-producer-link"
                      >Crea tu experiencia</span
                    >
                  </div>
                </div>
              </a>
            </li>

            <!-- Menú dinámico basado en menuItems -->
            <ng-container *ngIf="sidebarReady">
              <ng-container *ngFor="let item of menuItems">
                <li
                  *appValidateAccess="item.access"
                  class="px-3 py-2 rounded-sm mb-0.5 last:mb-0"
                  [ngClass]="
                    isMenuItemActive(item)
                      ? 'sidebar-element-expanded bg-slate-900'
                      : ''
                  "
                  cdkAccordion
                >
                  <cdk-accordion-item #accordionItem="cdkAccordionItem">
                    <a
                      class="block text-slate-200 truncate transition duration-150 cursor-pointer"
                      (click)="
                        accordionItem.toggle();
                        behaviourStates.sidebarOpen = true
                      "
                      data-testid="app-layout-menu-item-toggle"
                      data-test-desc="Enlace para expandir o colapsar un ítem del menú lateral"
                    >
                      <div class="flex items-center justify-between">
                        <div class="flex items-center">
                          <!-- <i [class]="'fa-duotone ' + item.icon + ' shrink-0 h-6 w-6 pointer-events-none'"></i> -->

                          <div [innerHTML]="item.svg | trustedHtml"></div>

                          <span
                            class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                          >
                            {{ item.label }}
                          </span>
                        </div>
                        <div
                          class="flex shrink-0 ml-2 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                        >
                          <svg
                            class="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400"
                            viewBox="0 0 12 12"
                            [ngClass]="
                              accordionItem.expanded ? 'rotate-180' : 'rotate-0'
                            "
                          >
                            <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                          </svg>
                        </div>
                      </div>
                    </a>
                    <div
                      class="lg:!hidden lg:sidebar-expanded:!block sidebar-element-expanded:block"
                    >
                      <ul
                        class="pl-9 mt-1"
                        [ngClass]="accordionItem.expanded ? 'block' : 'hidden'"
                      >
                        <li
                          class="mb-1 last:mb-0"
                          *ngFor="let subItem of item.subItems"
                        >
                          <a
                            class="block text-slate-400 hover:text-slate-200 transition duration-150 truncate"
                            [routerLink]="subItem.routerLink"
                            *appValidateAccess="subItem.access"
                            [queryParams]="subItem.queryParams || null"
                            [ngClass]="
                              isRouteActive(subItem.routerLink)
                                ? '!text-gl-blue'
                                : ''
                            "
                            (click)="
                              subItem.action === 'openModalFilterReport' &&
                                openModalFilterReport(
                                  subItemAccessReportKey(subItem.access)
                                )
                            "
                            [attr.data-testid]="subMenuTestId(subItem.label)"
                            data-test-desc="Enlace de submenú del sidebar"
                          >
                            <span
                              class="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                            >
                              {{ subItem.label }}
                              <span
                                *ngIf="subItem.notification"
                                class="inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full ml-2"
                              >
                                {{ subItem.notification }}
                              </span>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </cdk-accordion-item>
                </li>
              </ng-container>
            </ng-container>

            <!-- Reportes (mantenido por compatibilidad) -->
            <li
              *ngIf="sidebarReady && reportVisibility.menu"
              class="px-3 py-2 rounded-sm mb-0.5 last:mb-0"
              cdkAccordion
            >
              <cdk-accordion-item #accordionItemReports="cdkAccordionItem">
                <a
                  class="block text-slate-200 truncate transition duration-150 cursor-pointer"
                  (click)="
                    accordionItemReports.toggle();
                    behaviourStates.sidebarOpen = true
                  "
                  data-testid="app-layout-reports-toggle"
                  data-test-desc="Enlace para expandir o colapsar la sección de reportes"
                >
                  <div class="flex items-center justify-between">
                    <div class="flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="shrink-0 h-6 w-6 pointer-events-none"
                        width="44"
                        height="44"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="#2c3e50"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path
                          d="M14 3v4a1 1 0 0 0 1 1h4"
                          class="fill-current"
                        />
                        <path
                          d="M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3"
                          class="fill-current text-slate-400"
                        />
                      </svg>
                      <span
                        class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                        >Reportes</span
                      >
                    </div>
                    <div
                      class="flex shrink-0 ml-2 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                    >
                      <svg
                        class="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400"
                        viewBox="0 0 12 12"
                        [ngClass]="
                          accordionItemReports.expanded
                            ? 'rotate-180'
                            : 'rotate-0'
                        "
                      >
                        <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                      </svg>
                    </div>
                  </div>
                </a>
                <div
                  class="lg:!hidden lg:sidebar-expanded:!block sidebar-element-expanded:block"
                >
                  <ul
                    class="pl-9 mt-1"
                    [ngClass]="
                      accordionItemReports.expanded ? 'block' : 'hidden'
                    "
                  >
                    <li class="mb-1 last:mb-0">
                      <a
                        class="block text-slate-400 hover:text-slate-200 transition duration-150 truncate cursor-pointer"
                        (click)="openModalFilterReport('REPORTE_BOLETOS_EXP')"
                        *ngIf="reportVisibility.tickets"
                        data-testid="app-layout-report-boletos-link"
                        data-test-desc="Enlace para abrir reporte de boletos"
                      >
                        <span
                          class="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                        >
                          Boletos
                        </span>
                      </a>
                    </li>

                    <li class="mb-1 last:mb-0">
                      <a
                        class="block text-slate-400 hover:text-slate-200 transition duration-150 truncate cursor-pointer"
                        (click)="openModalFilterReport('REPORTE_TAQUILLA_EXP')"
                        *ngIf="reportVisibility.experienceBoxOffice"
                        data-testid="app-layout-report-taquilla-exp-link"
                        data-test-desc="Enlace para abrir reporte de taquilla experiencia"
                      >
                        <span
                          class="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                        >
                          Taquilla Experiencia
                        </span>
                      </a>
                    </li>
                    <li class="mb-1 last:mb-0">
                      <a
                        class="block text-slate-400 hover:text-slate-200 transition duration-150 truncate cursor-pointer"
                        (click)="
                          openModalFilterReport('REPORTE_TAQUILLA_GLOBAL_EXP')
                        "
                        *ngIf="reportVisibility.globalBoxOffice"
                        data-testid="app-layout-report-taquilla-global-link"
                        data-test-desc="Enlace para abrir reporte de taquilla global"
                      >
                        <span
                          class="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                        >
                          Taquilla Global
                        </span>
                      </a>
                    </li>
                    <li class="mb-1 last:mb-0">
                      <a
                        class="block text-slate-400 hover:text-slate-200 transition duration-150 truncate cursor-pointer"
                        (click)="
                          openModalFilterReport(
                            'REPORTE_BOLETOS_ELIMINADOS_EXP'
                          )
                        "
                        *ngIf="reportVisibility.deletedTickets"
                        data-testid="app-layout-report-boletos-eliminados-link"
                        data-test-desc="Enlace para abrir reporte de boletos eliminados"
                      >
                        <span
                          class="text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200"
                        >
                          Boletos eliminados
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </cdk-accordion-item>
            </li>
          </ul>
        </div>
      </div>
      <div class="pt-3 hidden lg:inline-flex justify-end mt-auto">
        <div class="px-3 py-2">
          <button
            (click)="toggleSidebar()"
            data-testid="app-layout-toggle-sidebar-btn"
            data-test-desc="Botón para expandir o colapsar el sidebar"
          >
            <span class="sr-only">Expand / collapse sidebar</span>
            <svg
              class="w-6 h-6 fill-current sidebar-expanded:rotate-180"
              viewBox="0 0 24 24"
            >
              <path
                class="text-slate-400"
                d="M19.586 11l-5-5L16 4.586 23.414 12 16 19.414 14.586 18l5-5H7v-2z"
              />
              <path class="text-slate-600" d="M3 23H1V1h2z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="relative flex flex-col flex-1 overflow-y-hidden overflow-x-hidden"
  >
    <header class="sticky top-0 bg-white border-b border-slate-200 z-30">
      <div class="px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16 -mb-px">
          <div class="flex">
            <button
              class="text-slate-500 hover:text-slate-600 lg:hidden"
              (click)="toggleSidebar()"
              data-testid="app-layout-open-sidebar-btn"
              data-test-desc="Botón para abrir el sidebar en móvil"
            >
              <span class="sr-only">Open sidebar</span>
              <svg
                class="w-6 h-6 fill-current"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="4" y="5" width="16" height="2" />
                <rect x="4" y="11" width="16" height="2" />
                <rect x="4" y="17" width="16" height="2" />
              </svg>
            </button>

            <!-- Botón Crear Experiencia -->
            <!-- EXP-005: gating por permiso. Sin CREAR_INFORMACION_EXP, el boton se oculta. -->
            <a
              *appValidateAccess="'CREAR_INFORMACION_EXP'"
              routerLink="/home/producer"
              class="ml-4 flex items-center px-4 py-2 text-sm font-medium text-white bg-[var(--color-primary)] rounded-md hover:bg-[var(--color-primary-dark)] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              data-testid="app-layout-create-experience-btn"
              data-test-desc="Botón para crear una nueva experiencia"
            >
              <svg
                class="w-5 h-5 md:mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="hidden sm:inline">Crear Experiencia</span>
            </a>
          </div>

          <!-- <div class="flex items-center space-x-3">
            <app-timezone-selector></app-timezone-selector>
          </div> -->

          <div class="flex items-center space-x-3">
            <!-- Inspector de permisos (solo super admin): etiqueta cada elemento con el permiso que lo habilita. -->
            <ng-container *ngIf="sessionAuthState.is_super_admin">
              <ng-container *ngIf="{ on: permissionInspector.enabled$ | async } as inspector">
                <button
                  type="button"
                  (click)="permissionInspector.toggle()"
                  class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md border transition duration-150"
                  [ngClass]="
                    inspector.on
                      ? 'bg-indigo-600 border-indigo-600 text-white hover:bg-indigo-700'
                      : 'bg-white border-slate-200 text-slate-600 hover:text-slate-800 hover:border-slate-300'
                  "
                  [attr.aria-pressed]="inspector.on"
                  [attr.aria-label]="inspector.on ? 'Ocultar permisos' : 'Mostrar permisos de esta sección'"
                  [title]="inspector.on ? 'Ocultar permisos' : 'Mostrar permisos de esta sección'"
                >
                  <i class="fa-duotone fa-key" aria-hidden="true"></i>
                  <span class="hidden md:inline ml-2">{{
                    inspector.on ? 'Ocultar permisos' : 'Mostrar permisos de esta sección'
                  }}</span>
                </button>
              </ng-container>
            </ng-container>

            <!-- Divider -->
            <hr class="w-px h-6 bg-slate-200" />

            <!-- User button -->
            <div id="user-menu" class="relative inline-flex">
              <button
                (click)="toggleUserMenu()"
                class="inline-flex justify-center items-center group"
                data-testid="app-layout-user-menu-btn"
                data-test-desc="Botón para abrir el menú de usuario"
              >
                <img
                  class="w-8 h-8 rounded-full"
                  [src]="
                    sessionUserState.google_user_photo
                      ? sessionUserState.google_user_photo
                      : '/assets/images/general/profile-placeholder.png'
                  "
                  src="/assets/images/brand/goliiive_logo_blue_iso.svg"
                  width="32"
                  height="32"
                  alt="User"
                />
                <div class="flex items-center truncate">
                  <span
                    class="truncate ml-2 text-sm font-medium group-hover:text-slate-800"
                    >{{ sessionUserState.user_name }}
                    {{ sessionUserState.user_last_name }}</span
                  >
                  <svg
                    class="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400"
                    viewBox="0 0 12 12"
                  >
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"></path>
                  </svg>
                </div>
              </button>

              <div
                [@fadeInOutY]="userMenuOpen ? 'in' : 'out'"
                [ngClass]="
                  userMenuOpen ? 'pointer-events-auto' : 'pointer-events-none'
                "
                class="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-hidden mt-1"
              >
                <div class="pt-0.5 pb-2 px-3 mb-1 border-b border-slate-200">
                  <div class="font-medium text-slate-800">
                    {{ sessionUserState.user_name }}
                    {{ sessionUserState.user_last_name }}
                  </div>
                  <div class="text-xs text-slate-500 italic">
                    {{ sessionUserState.email }}
                  </div>
                </div>
                <ul>
                  <li>
                    <button
                      (click)="goToAccount()"
                      class="font-medium text-sm text-gl-blue hover:text-indigo-600 flex items-center py-1 px-3"
                      data-testid="app-layout-profile-btn"
                      data-test-desc="Botón para ir al perfil del usuario"
                    >
                      Perfil
                    </button>
                  </li>
                  <li>
                    <button
                      (click)="clearSession()"
                      class="font-medium text-sm text-gl-blue hover:text-indigo-600 flex items-center py-1 px-3"
                      data-testid="app-layout-logout-btn"
                      data-test-desc="Botón para cerrar sesión"
                    >
                      Cerrar Sesión
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <main
      class="flex flex-col max-h-[calc(100vh-4rem)] overflow-y-auto overflow-x-hidden min-h-0"
      cdk-scrollable
    >
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
<app-filter-report
  #FilterReportComponent2
  [isModal]="true"
  [instance]="1"
  [showBottom]="false"
  class="hidden"
  *ngIf="refreshReports"
  [filterReports]="filterReports"
></app-filter-report>
<!-- A-ARQ-005 — Cierre de caja desde el menú lateral (el mismo modal de la taquilla) -->
<app-cashier-close-modal
  *ngIf="showCashierCloseModal"
  (closed)="showCashierCloseModal = false"
  (dismissed)="showCashierCloseModal = false"
></app-cashier-close-modal>
